module.exports = __webpack_public_path__ + "img/svg/levels.819e98b3e347d0bca37b5f019800899b.svg";